import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false, name: 'mapLookup' })
export class MapLookupPipe implements PipeTransform {
  transform<K, V>(key: K | null | undefined, map: Map<K, V> | null | undefined, fallback: V = null as V): V {
    return key == null || !map ? fallback : (map.get(key) ?? fallback);
  }
}
